module.exports = __webpack_public_path__ + "static/media/address_image1.16559172.svg";